import Navbar from '../components/Navbar'
import Banner from '../components/Banner'
import Video from '../components/Video'
import Disclaimer from '../components/Disclaimer'

export default function Home() {
    return (
        <div className="min-h-screen flex flex-col">
            <Banner />
            <Navbar />
            <div className='background md:px-14 py-8 max-w-screen-4xl mx-auto'>
                <Video />
                <Disclaimer />
            </div>
        </div>
    )
}
